<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-tabs>
      <b-tab title="Precios por zona">
        <b-card>
          <b-table
              v-if="row.item.zonaPrecios !== null"
              ref="tablaDatosFiscales"
              thead-tr-class="columnas"
              :items="row.item.zonaPrecios"
              :fields="encabezadosDetalleZona"
              class="parrafos"
              striped
              responsive
          >
            <template v-slot:cell(precio)="row">
          <span>
            {{row.item.precio | moneda}}
          </span>
            </template>
            <template v-slot:cell(precioExtranjero)="row">
          <span>
            {{row.item.precioExtranjero | moneda}}
          </span>
            </template>
          </b-table>
          <h4 v-else><b-badge variant="warning">NO HAY DATOS</b-badge></h4>
        </b-card>
      </b-tab>
      <b-tab title="Precios por clínica">
        <b-card>
          <b-table
              v-if="row.item.clinicasZonaPrecios !== null"
              ref="tablaDatosFiscales"
              thead-tr-class="columnas"
              :items="row.item.clinicasZonaPrecios"
              :fields="encabezadosDetalleClinica"
              class="parrafos"
              striped
              responsive
          >
            <template v-slot:cell(precio)="row">
          <span>
            {{row.item.precio | moneda}}
          </span>
            </template>
            <template v-slot:cell(precio)="row">
          <span>
            {{row.item.precioExtranjero | moneda}}
          </span>
            </template>

          </b-table>
          <h4 v-else><b-badge variant="warning">NO HAY DATOS</b-badge></h4>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "DetallePrecios",
  props: {
    row: Array
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    encabezadosDetalleZona: [
      { key: "nombreZona", label: "Zona" },
      { key: "precio", label: "Precio" },
      { key: "precioExtranjero", label: "Precio Extranjero" },
      { key: "bonoIndividualOg", label: "Bono individual OG's" },
      { key: "comisionBaseEspecialistas", label: "Comisión base especialistas" },
      { key: "comisionMasBonoEspecialistas", label: "Comisión más bono especialistas" },
      { key: "bonoTrimestral", label: "Bono trimestral OG's" },
      { key: "comisionBaseOG", label: "Comisión base OG's" },
    ],
    encabezadosDetalleClinica: [
      { key: "strNombre", label: "Clínica" },
      { key: "precio", label: "Precio" },
      { key: "precioExtranjero", label: "Precio Extranjero" },
      { key: "bonoIndividualOg", label: "Bono individual OG's" },
      { key: "comisionBaseEspecialistas", label: "Comisión base especialistas" },
      { key: "comisionMasBonoEspecialistas", label: "Comisión más bono especialistas" },
      { key: "bonoTrimestral", label: "Bono trimestral OG's" },
      { key: "comisionBaseOG", label: "Comisión base OG's" },
    ],

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>

</style>
